<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: 'Secondary'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=212-73560&m=dev'
 */
import IconContainer from '@UI/Other/IconContainer.vue'

defineOptions({
  name: 'BtnSecondary',
})

withDefaults(defineProps<BtnSecondaryProps>(), {
  text: '',
  disabled: false,
  size: 'medium',
  elementWidth: 'auto',
  selected: false,
  color: 'blue',
})

const emit = defineEmits<{
  click: []
}>()

interface BtnSecondaryProps {
  text?: string
  disabled?: boolean
  size?: 'big' | 'medium' | 'small'
  elementWidth?: 'auto' | 'full'
  selected?: boolean
  color?: 'blue' | 'gray'
}
const handleClick = (): void => {
  emit('click')
}

</script>

<template>
  <button
    type="button"
    :class="['ui-btn-secondary', size, elementWidth, color, { disabled }, { selected } ]"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      v-if="$slots.iconLeft"
      :class="[`container-${size}`]"
    >
      <slot name="iconLeft" />
    </IconContainer>
    <slot>
      <span class="ui-btn-secondary__text">
        {{ text }}
      </span>
    </slot>
    <IconContainer
      v-if="$slots.iconRight"
      :class="[`container-${size}`]"
    >
      <slot
        name="iconRight"
      />
    </IconContainer>
    <slot name="tooltip" />
  </button>
</template>

<style scoped lang="scss" src="@scss/components/UI/Buttons/BtnSecondary.scss" />
